import React, {useEffect, useState} from "react";
import { Col, Row } from "reactstrap";
import {connect} from "react-redux";

// components
import PersonalTitleList from "./_list";
import PersonalTitleForm from "./_form";
import {ButtonNew, ButtonSync} from "../../../components/buttons/buttonsActions";

// actions
import {setApp, clearState} from '../../../redux/actions/generalActions/mainActions'
import {showLoader} from "../../../components/loader/loader";
import {personalTitleService} from "../../../jwt/_services/hotel/personalTitleService";

const PersonalTitle = props => {
    const [viewMode, setViewMode] = useState("LIST")
    const [editMode, setEditMode] = useState(false);
    const [itemToEdit, setItemToEdit] = useState();

    const [loading, setLoading] = useState(false);
    const [updateList, setUpdateList] = useState(false);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(props.app);

        return () => {
            props.clearState()
        }
    },[])

    const setForm = (editModeP, itemToEdit, viewModeP) => {
        setEditMode(editModeP ? editModeP : editMode);
        setItemToEdit(itemToEdit);
        setViewMode(viewModeP ? viewModeP : "LIST")
    }

    const updateItemToEdit = (item) => setItemToEdit(item)

    const syncFirebase = () => {
        setLoading(true);

        const requestData= {
            fbDataBase: { id: props.app?.fbDataBase.id }
        }

        personalTitleService.sync(requestData)
            .then(_ => setUpdateList(!updateList) )
            .catch(errorMessage => console.error(errorMessage))
            .finally(() => setLoading(false));
    }

    return <>
        { loading && showLoader() }
        <Row>
            <Col>
                <div className="d-flex align-items-center">
                    {
                        viewMode === "LIST" && <div className="ml-auto paddingAdd">
                            <ButtonSync onClick={syncFirebase}/>
                            <ButtonNew onClick={() => setForm(null, null, "FORM")}/>
                        </div>
                    }
                </div>
            </Col>
        </Row>
        <Row>
            <Col>
                {(
                    function() {
                        switch (viewMode) {
                            case "LIST" :
                                return <PersonalTitleList
                                    setForm={ setForm }
                                    app={props.app}
                                    updateList={updateList}
                                />
                            case "FORM" :
                                return <PersonalTitleForm
                                    setForm={ setForm }
                                    updateItem={ updateItemToEdit }
                                    item={ itemToEdit }
                                    editMode={ editMode }
                                    app={props.app}
                                />
                            default:
                                return null;
                        }
                })()}

            </Col>
        </Row>
    </>
}

const mapStateToProps = state => ({});

const mapActionsToProps = ({
    clearState,
    setApp
});

export default connect(mapStateToProps, mapActionsToProps)(PersonalTitle)